import React, {memo, useEffect} from 'react';
import {Container} from '../Container';
import {useLocation} from 'react-router-dom';

import './index.scss';
import {useRPC} from '../../hooks/rpc';
import {useLocalization} from "../../hooks/localization";

export const NotFound404 = memo(function NotFound404() {
    const {t} = useLocalization();
    const location = useLocation();
    const [rpc] = useRPC();

    useEffect(() => {
        const path = location?.pathname || null;
        if (path != null) {
            rpc.sendBrokenLink(location.pathname)
                .catch(() => {
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <div className='not-found-404'>
                <span className='text'>{t('SORRY__PAGE_YOU_ARE_LOOKING_FOR_COULD_NOT_BE_FOUND')}</span>
            </div>
        </Container>
    );
});
